export const CLIENT_TAB = {
  SUMMARIES: "summaries",
  SETTINGS: "settings",
  HELP: "help",
};

export const CLIENT_TAB_LABEL = {
  SUMMARIES: "Summaries",
  SETTINGS: "Settings",
  FEEDBACK: "Feedback",
};
